<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">店铺中心</span>
      </div>
      <div class="gl_tb_right">
        <el-input placeholder="请输入店铺名称"
                  v-model="name"
                  size="small"
                  style="margin-bottom:10px;"
                  class="input-with-select">
          <el-button slot="append"
                     @click="GetMyStoreList"
                     icon="el-icon-search"></el-button>
        </el-input>
      </div>
    </div>
    <div class="boxtop"
         v-show="storeList.orglist&&storeList.orglist.length>0">机构店铺</div>
    <div class="box"
         v-for="(item,index) in storeList.orglist"
         :key="index+'org'"
         @click="toStore(item.id,item.name)"
         :class="(index+4)%4==0?'boxbg1':((index+4)%4==1?'boxbg2':((index+4)%4==2?'boxbg3':'boxbg4'))">
      <div class="boxmystop">我的店铺</div>
      <img :src="item.coverpicture"
           class="orgImg"
           alt="">
      <span>{{item.name}}</span>
    </div>
    <div class="boxtop"
         v-show="storeList.exlist&&storeList.exlist.length>0">专家店铺</div>
    <div class="box2"
         v-for="(item,index) in storeList.exlist"
         :key="index+'ex'"
         @click="toAdmin(item.id,item.name)"
         :class="(index+4)%4==0?'boxbg3':((index+4)%4==1?'boxbg4':((index+4)%4==2?'boxbg1':'boxbg2'))">
      <div class="boxmystop">我的店铺</div>
      <div class="imgbox">
        <img :src="item.coverpicture"
             alt="">
      </div>
      <span style="font-weight: bold;">{{item.name}}</span>
    </div>

    <div class="no"
         v-if="storeList.orglist&&storeList.exlist"
         v-show="storeList.orglist.length==0&&storeList.exlist.length==0">
      <img src="../../assets/img/no.png"
           alt="">
      <span>暂无店铺信息</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userStoreCenter',
  data () {
    return {
      storeList: '',
      name: ''
    };
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
      this.GetMyStoreList()
    }
  },
  methods: {
    GetMyStoreList () {
      this.httphelper.get('/api/CGPEnterPriseApi/GetMyStoreList', {
        userId: Number(this.AuthorId),
        name: this.name
      })
        .then(res => {
          if (res.data) {
            this.storeList = res.data
          }
        });
    },
    toStore (id, name) {
      localStorage.setItem('storeId', id);
      localStorage.setItem('storeType', 2);
      localStorage.setItem('storeName', name);
      this.$router.push({
        // name: 'usCourse'
        name: 'usProject'
      })
    },
    toAdmin (id, name) {
      localStorage.setItem('storeId', id);
      localStorage.setItem('storeName', name);
      localStorage.setItem('storeType', 1);
      this.$router.push({
        name: 'uaInfor'
      })
    }
  }
};
</script>

<style scoped>
.boxtop {
    height: 18px;
    width: 100%;
    padding-left: 16px;
    margin: 34px 0 20px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    border-left: 2px solid #0b8586;
    line-height: 18px;
}
.box {
    width: 304px;
    height: 180px;
    position: relative;
    margin: 0px 19px 19px 0;
    box-shadow: 5px 9px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    /* padding: 50px 24px 0px; */
    /* padding-bottom: 42px; */
    padding-bottom: 28px;
    display: flex;
    align-items: center;
    /* justify-content: center; */
    justify-content: flex-end;
    flex-direction: column;
    box-sizing: border-box;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
    cursor: pointer;
    display: inline-flex;
}
.box span {
    text-align: center;
    height: 48px;
}
.boxmystop {
    width: 76px;
    height: 26px;
    background: #10194b;
    opacity: 0.6;
    border-radius: 10px 0px 5px 0px;
    font-size: 12px;
    line-height: 26px;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
}
.box .orgImg {
    max-width: 133px;
    max-height: 53px;
    background: #ffffff;
    border-radius: 6px;
    margin-bottom: 15px;
}
.boxbg1 {
    background-image: url(../../assets/img/store/bg1.png);
}
.boxbg2 {
    background-image: url(../../assets/img/store/bg2.png);
}
.boxbg3 {
    background-image: url(../../assets/img/store/bg3.png);
}
.boxbg4 {
    background-image: url(../../assets/img/store/bg4.png);
}
.box2 {
    width: 304px;
    height: 180px;
    position: relative;
    margin: 0px 19px 19px 0;
    box-shadow: 5px 9px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 45px 0px 40px;
    display: flex;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: space-between;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
    cursor: pointer;
    display: inline-flex;
}
.box2 img {
    width: 54px;
    height: 54px;
    margin: 3px;
    border-radius: 50%;
}
.box2 .imgbox {
    width: 60px;
    height: 60px;
    background: #ffffff;
    border-radius: 50%;
}
.no {
    width: 100%;
    height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: rgb(149, 149, 149);
    font-size: 20px;
}
.no img {
    width: 180px;
    height: 130px;
    margin-bottom: 30px;
}
</style>